
const blogSingleUrl = '/foo'

function blogMDUrlToRenderUrl(mdurl) {
    const urlTitle = mdurl.substring(mdurl.lastIndexOf("/") + 1, mdurl.lastIndexOf("."));
    return `${blogSingleUrl}/${urlTitle}`
}

export default blogMDUrlToRenderUrl;